<template>
  <div class="w-100" style="position: relative;">
    <v-label v-if="label" :label="label"></v-label>
    <div class="input-group">
      <input
        ref="pesquisa"
        class="form-control form-control-sm"
        autocomplete="off"
        type="text"
        :placeholder="placeholder"
        v-model="textSearch"
        @blur="handleBlur"
        @keyup.esc="handleEsc"
        @keydown.enter.prevent="handleSelect()"
        @keyup.down="handleKeyDown"
        @keyup.up="handleKeyUp"
      />
    </div>
    <transition name="fade">
      <div class="col-md-12 col-12 p-0" v-if="showList" style="position: absolute; z-index: 1000; width: 100%;">
        <ul ref="list" class="typeahead typeahead-dropdown col" style="display: block; margin-top: 0; max-height: 300px; overflow-y: auto;">
          <li v-if="list.length === 0">
            <div><span class="typeahead-data">Nenhum dado localizado</span></div>
          </li>
          <li
            v-for="(item, index) in list"
            :key="index"
            :class="{ active: index === selectedIndex }"
            @mousedown.prevent="handleSelect(index)"
            style="cursor: pointer;"
          >
            <div>
              <span class="typeahead-title">
                <small>{{ item.value || item.descricao || item.nome }}</small>
              </span>
              <span class="typeahead-data float-right" v-if="item.id || item.codigo">
                <small>{{ item.id || item.codigo }}</small>
              </span>
            </div>
          </li>
          <li v-if="has_more" @mousedown.prevent="handleMore()" style="cursor: pointer; text-align: center; background-color: #f8f9fa;">
            <div>
              <span class="typeahead-title">
                <small><strong>Exibir Mais</strong></small>
              </span>
            </div>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'input-search',
  props: {
    value: {}, // Pode ser o ID (se selecionado) ou o texto (se não selecionado)
    label: { type: String },
    placeholder: { type: String, default: 'Pesquisar...' },
    entity: { type: String, required: true }, // Endpoint ORDS, ex: 'cliente' ou 'cliente/'
  },
  data() {
    return {
      textSearch: '',
      showList: false,
      list: [],
      selectedIndex: 0,
      selectedId: null,
      keytimer: null,
      isSelecting: false,
      has_more: false,
      next_page: 0,
    };
  },
  watch: {
    textSearch(newVal, oldVal) {
      if (this.isSelecting) {
        this.isSelecting = false;
        return;
      }
      
      // Se alterou o texto manualmente, não temos mais um ID selecionado
      this.selectedId = null;
      this.$emit('input', newVal); // Atualiza o v-model com o texto informado

      if (this.keytimer) clearTimeout(this.keytimer);
      
      if (!newVal) {
        this.showList = false;
        this.list = [];
        this.has_more = false;
        this.next_page = 0;
        return;
      }
      
      this.keytimer = setTimeout(() => {
        this.search();
      }, 300);
    },
    value: {
      immediate: true,
      handler(val) {
        // Quando o componente pai atualiza o valor
        if (val !== this.selectedId && val !== this.textSearch) {
          this.textSearch = val || '';
        }
      }
    }
  },
  methods: {
    handleBlur() {
      // Pequeno atraso para dar tempo do mousedown no item da lista ocorrer
      setTimeout(() => {
        this.showList = false;
      }, 150);
    },
    handleEsc() {
      this.showList = false;
    },
    handleKeyDown() {
      if (this.list.length > 0) {
        if (this.selectedIndex >= this.list.length - 1) {
          this.selectedIndex = 0;
        } else {
          this.selectedIndex++;
        }
        this.fixScroll();
      }
    },
    handleKeyUp() {
      if (this.list.length > 0) {
        if (this.selectedIndex <= 0) {
          this.selectedIndex = this.list.length - 1;
        } else {
          this.selectedIndex--;
        }
        this.fixScroll();
      }
    },
    fixScroll() {
      if (this.$refs.list) {
        this.$nextTick(() => {
          const activeItem = this.$refs.list.querySelector('.active');
          if (activeItem) {
            activeItem.scrollIntoView({ block: 'nearest', inline: 'start' });
          }
        });
      }
    },
    handleSelect(index) {
      if (index !== undefined) {
        this.selectedIndex = index;
      }
      if (this.list.length > 0 && this.list[this.selectedIndex]) {
        let item = this.list[this.selectedIndex];
        this.isSelecting = true;
        this.textSearch = item.value || item.descricao || item.nome;
        this.selectedId = item.id || item.codigo;
        this.showList = false;
        
        // Emite o ID selecionado
        this.$emit('input', this.selectedId);
        this.$emit('change', item);
      }
    },
    handleMore() {
      this.search(true);
    },
    search(loadMore) {
      if (!this.entity) return;
      
      if (!loadMore) {
        this.next_page = 0;
      }

      let term = this.textSearch.toUpperCase();
      let endpoint = this.entity;
      if (!endpoint.endsWith('/')) {
        endpoint += '/';
      }
      
      let url = this.$store.getters.urlOrdsSelect + endpoint + '?q={"value":{"$like":"%25' + term + '%25"}}';
      if (this.next_page > 0) {
        url += '&offset=' + this.next_page;
      }
      
      jQuery.ajax({
        beforeSend: (xhr) => {
          xhr.setRequestHeader("Authorization", "Bearer " + this.$store.getters.getEnv.token);
          xhr.setRequestHeader("uuid", this.$store.getters.getEnv.uuid);
        },
        url: url,
        dataType: 'json',
        success: (data) => {
          if (data && data.items) {
            if (loadMore) {
              this.list.push(...data.items);
            } else {
              this.list = data.items;
              this.selectedIndex = 0;
            }
            this.showList = true;
            this.has_more = data.hasMore;
            if (data.hasMore) {
              this.next_page = (data.offset || 0) + (data.limit || data.count || 25);
            }
          }
        }
      });
    }
  }
}
</script>

<style scoped>
li {
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/input-search.vue